import { useContext } from "react";
import { Row, Col } from "antd";

import { TvPlanContext } from "../../contexts/tvplancontext";
import TvPlanFav from "../TvPlanFav";

import "./index.css";


export default function TvPlanFavList() {
    const ctx = useContext(TvPlanContext);
    const plan = ctx.getStarterPlan();
    const planData = plan?.data || {};
    const favs = planData?.favs || {};

    if (Object.keys(favs).length < 1) {
        return null;
    }

    return (
        <Row
            gutter={[10, 10]}
            wrap={true}
            className="tv-plan-fav-list"
        >
            {favs.map(favCode => (
            <Col  key={`starter-fav-${favCode}`} flex="auto" xs={24} sm={12} lg={8}>
                <TvPlanFav code={favCode} />
            </Col>
            ))}
        </Row>
    );
}
